import { ApiResponse } from 'shared/model/types';

export const isEmailVerificationRequiredInResponse = (response: ApiResponse<any>): boolean => {
  const messages = response?.messages || [];
  return messages.some(
    (msg) => {
      const id = msg.id?.toLowerCase() || '';
      return (
        id === 'schemas.email.not.verified' ||
        (id.includes('email') && id.includes('not.verified')) ||
        (id.includes('email') && id.includes('not verified'))
      );
    }
  );
};

export const isPhoneVerificationRequiredInResponse = (response: ApiResponse<any>): boolean => {
  const messages = response?.messages || [];
  return messages.some(
    (msg) => {
      const id = msg.id?.toLowerCase() || '';
      return (
        id === 'schemas.phone.not.verified' ||
        (id.includes('phone') && id.includes('not.verified')) ||
        (id.includes('phone') && id.includes('not verified'))
      );
    }
  );
};

